import React from "react";

const Footer = () => {
  return (
    <>
      <h5 className="text-sm text-center">
        Design inspired from{" "}
        <a className="text-[#ea4c89]" href="www.dribble.com">
          Dribble
        </a>
        <br />
        <h3 className="text-lg mt-2">
          Developed by{" "}
          <a className="text-[#5777f5]" href="https://github.com/Deepakmukka1">
            Mukka Deepak
          </a>
        </h3>
      </h5>
    </>
  );
};

export default Footer;
